import React, { useState } from "react";

// Define fields directly
const clinicalFields = [
  { key: "studyType", label: "Study Type" },
  { key: "significance", label: "Significance" },
  { key: "validation", label: "Validation" },
  { key: "references", label: "References (URL or text)" },
];

export default function ScientificClinicalInformationForm({ data, onChange, onBack, onSubmit }) {
  const processes = data.processes || [];
  const [selectedIndex] = useState(processes.length > 0 ? 0 : -1);

  const setProcessField = (key, value) => {
    if (selectedIndex < 0) return;
    const updatedProcesses = [...processes];
    updatedProcesses[selectedIndex] = { 
      ...updatedProcesses[selectedIndex], 
      [key]: value 
    };
    onChange("processes", updatedProcesses);
  };

  return (
    <div>
      <h4 className="text-success">Scientific & Clinical Information</h4>

      {processes.length === 0 ? (
        <div className="alert alert-warning" role="alert">
          No processes added yet. Please go back to the "Process Specification" step.
        </div>
      ) : (
        <>
          {selectedIndex >= 0 && (
            <div>
              {clinicalFields.map(({ key, label }) => (
                <div className="mb-3" key={key}>
                  <label className="form-label">{label}</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder={`Enter ${label}`}
                    value={processes[selectedIndex]?.[key] ?? ""}
                    onChange={(e) => setProcessField(key, e.target.value)}
                  />
                </div>
              ))}
            </div>
          )}
        </>
      )}

      <div className="d-flex justify-content-between mt-3">
        <button type="button" className="btn btn-secondary" onClick={onBack}>
          Back
        </button>
        <button type="button" className="btn btn-success" onClick={onSubmit}>
          Submit Application
        </button>
      </div>
    </div>
  );
}
